import styled from 'styled-components';
import Text from '@deprecated-ui/common/Text';
import Table from '@deprecated-ui/common/Table';
import color from '@deprecated-ui/_style/color';

const SHeader = styled.h5`
  background: ${color.light};
  border-radius: 3px;
  border: 1px solid ${color.gainsboro};
  color: ${color.dimgray};
  cursor: pointer;
  display: flex;
  font-family: var(--bold-font);
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 15px;
  margin: 0px;
  margin-bottom: 20px;
  max-width: 100%;
  padding: 15px 20px;
  position: relative;
  text-overflow: ellipsis;
`;

const SContainer = styled.div`
  position: relative;
  display: block;
  width: 100%;
  padding-bottom: 40px;
`;

const SBody = styled.div`
  position: relative;
  display: block;
  width: 100%;
  padding: 20px;
  background: ${color.light};
  border: 1px solid ${color.gainsboro};
  border-radius: 3px;

  .ant-modal-content button .ant-modal-close-x {
    width: 40px;
    height: 40px;
    line-height: 2.5;
  }
`;

const SBodyWrapperTop = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  margin-bottom: 10px;
`;

const SearchWrapper = styled.div`
  display: flex;
  width: 100%;

  .ant-select .ant-select-selector {
    border-radius: 3px;
  }

  .ant-select .ant-select-selector .ant-select-selection-search button {
    border-radius: 0 3px 3px 0 !important;
  }
  @media screen and (min-width: 721px) {
    gap: 20px;
    .sector-search,
    .symbol-search {
      width: 300px;
    }
  }
`;

const Th = styled(Text).attrs({ family: 'bold', align: 'right' })`
  font-size: 14px;
  padding-right: 8px;
`;

const TableEarnings = styled(Table)`
  font-family: var(--regular-font);
  font-size: 13px;
  margin: 20px 0px;

  .ant-table-container {
    border-radius: 3px;
  }
  .ant-table-container,
  th,
  td {
    border-color: ${color.gainsboro} !important;
  }

  table th,
  table td {
    padding: 4px 10px;
    text-align: right;

    &.symbol {
      text-align: left;
    }
  }

  .symbol {
    & .ant-table-column-sorters {
      justify-content: flex-start;
    }
  }

  .ant-table-column-sorters {
    display: flex;
    justify-content: flex-end;
    padding: 6px 14px;
    width: 100%;
  }

  .ant-table-tbody > tr > td {
    padding: 4px 10px;
  }
`;

const TableEarningWrapper = styled.div`
  padding: 10px;
`;
const TableEarning = styled.table`
  width: 100%;

  td {
    width: 33.33%;
    padding: 5px;
  }
`;

const ModalIconWrapper = styled.div`
  cursor: pointer;
`;

export {
  SBody,
  SBodyWrapperTop,
  SearchWrapper,
  SContainer,
  SHeader,
  Th,
  TableEarnings,
  TableEarningWrapper,
  TableEarning,
  ModalIconWrapper,
};
